import { render, staticRenderFns } from "./sixBody.vue?vue&type=template&id=78f9879e&scoped=true&"
import script from "./sixBody.vue?vue&type=script&lang=js&"
export * from "./sixBody.vue?vue&type=script&lang=js&"
import style0 from "./sixBody.vue?vue&type=style&index=0&id=78f9879e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f9879e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f9879e')) {
      api.createRecord('78f9879e', component.options)
    } else {
      api.reload('78f9879e', component.options)
    }
    module.hot.accept("./sixBody.vue?vue&type=template&id=78f9879e&scoped=true&", function () {
      api.rerender('78f9879e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/sixBody.vue"
export default component.exports